(ns common.db.effects.debounce
  (:require [common.debouncer :as debouncer]
            [re-frame.core :as rf]))

(def debounce
  (debouncer/make-key-based-debouncer))

(rf/reg-fx :debounce
  (fn [{:keys [id f delay-ms]}]
    (debounce id delay-ms f)))

(rf/reg-fx :dispatch-debounced
  (fn [{:keys [id event delay-ms]}]
    (debounce id delay-ms #(rf/dispatch event))))
